import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import utils from '../utils/utils'
import keys from "../store/keys";
import wishlistService from "../services/wishlist";
import { swalError, swalSuccess, swalInfo } from "../utils/swal";
import CurrencyConverter from './CurrencyConverter';

function CheckoutItem({ session, setKey, ...props }) {

	const k = props.data;
	const [quantity, setQuantity] = useState(k.quantity);
	const [price, setPrice] = useState(parseFloat(k.selectedVariant.price));
	const [total, setTotal] = useState(quantity * parseFloat(k.selectedVariant.price));

	useEffect(() => {
		setTotal(quantity * parseFloat(k.selectedVariant.price));
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		let item = t.find(p => p.id === k.id);
		item.quantity = quantity;
		localStorage.setItem(keys.cart, JSON.stringify(t));
		setKey(keys.counter, parseInt(session.counter) + 1);
	}, [quantity]);

	const handleRemoveItem = (e, id) => {
		e.preventDefault();
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		t = t.filter(p => p.id !== id);
		localStorage.setItem(keys.cart, JSON.stringify(t));
		setKey(keys.counter, parseInt(session.counter) + 1);
	}

	const handleMakeFavorite = e => {
		e.preventDefault();

		if(k && k.product._id) {
		const productId = k.product._id;
		wishlistService.create(session.token, productId)
			.then(result => {
				if (result.error) {
					swalInfo(result.error);
					return;
				}

				swalSuccess(`Product added successfully!`);
			});
		}
	}

	return (
		<>
			<tr key={k.id}>
				<td colSpan={2} className="text-start">	
					<input type="hidden" id="txt-productId" value={k.product._id} />
					<input type="hidden" id="txt-variantId" value={k.selectedVariant._id} />
					<div className="row text-start">
						<div className="col-5">
							<img
								className="cart-img"
								src={k.product.images[0].fileUrl}
							/>
						</div>
						<div className="col-7">
							<span className="truncate-2 td-strong">{k.product.title}</span>
							<span className="truncate-1">Size: {k.selectedVariant.size}</span>
						</div>
					</div>
				</td>
				<td>
					{utils.formatToCurrency(price, k.currency)}
				</td>
				<td>
					<input
						type="number"
						value={quantity}
						onChange={e => setQuantity(e.target.value)}
						className="form-control"
						style={{ width: 60 }}
						min={1}
						step={1} />
				</td>
				<td className="text-end">
					<p className="mb-100">{utils.formatToCurrency(total, k.currency)}</p>
					<button className="btn btn-link btn-cart" onClick={e => handleRemoveItem(e, k.id)}>Remove</button>
					<span style={{color: '#ddd'}}>|</span> 
					<button className="btn btn-link btn-cart" onClick={handleMakeFavorite}>Save for Later</button>
				</td>
			</tr>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutItem);
